<template>
  <div>
    <div class="container mt-4">
      <div class="row shadow-sm p-3 mb-5 bg-body rounded">
        <div class="col-12">
          <!-- IMAXHI I PARË -->
          <img
            v-if="mainImage"
            :src="fullUrl(mainImage)"
            class="rounded img-fluid float-start me-3 mb-3"
            alt="Post Image"
          />

          <div v-if="postStore.loading">Loading...</div>
          <div v-if="postStore.error">{{ postStore.error }}</div>

          <div v-if="!postStore.loading && !postStore.error && postStore.post">
            <h3>{{ postStore.post.priceDetailsTitle || 'No Title' }}</h3>
            <div v-html="postStore.post.pDetailsContent || 'No Content'"></div>

            <!-- IMAXHET TJERA PAS KONTENTIT -->
            <div v-if="otherImages.length" class="extra-images mt-4">
              <!-- <h5>Imazhet tjera:</h5> -->
              <div class="d-flex flex-wrap gap-3">
                <img
                  v-for="(img, index) in otherImages"
                  :key="index"
                  :src="fullUrl(img)"
                  class="rounded img-fluid shadow-sm object-fit-cover"
                  style="width: 250px; cursor: pointer;"
                  @click="showPostInModal(fullUrl(img))"
                />
              </div>
            </div>
          </div>

          <div v-if="!postStore.loading && !postStore.error && !postStore.post">
            Post not found
          </div>
        </div>
      </div>
    </div>

    <!-- Modal për imazhin -->
    <div v-if="showModal" class="modal-overlay" @click="closeImageModal">
      <img :src="modalImageSrc" class="modal-image" />
    </div>
  </div>
</template>

<script>
import { usePostsStore } from '@/store/PostStore/postStore';
import Swal from 'sweetalert2';

export default {
  name: 'SingleArticle',

  data() {
    return {
      postStore: usePostsStore(),
      showModal: false,
      modalImageSrc: '',
      baseUrl: 'https://app-prokuroria.cmdsoftwares.com/uploads/', // përshtate sipas nevojës
    };
  },

  computed: {
    // ndan imazhin e parë nga të tjerat
    images() {
      const urls = this.postStore.post?.pDetailsFileUrl
        ? this.postStore.post.pDetailsFileUrl.split(',').map(u => u.trim())
        : [];
      return urls;
    },
    mainImage() {
      return this.images.length ? this.images[0] : null;
    },
    otherImages() {
      return this.images.length > 1 ? this.images.slice(1) : [];
    },
  },

  methods: {
    async fetchPostById() {
      const postData = {
        webPage: 'Këshilli Prokurorial i Kosovës',
        language: 'AL',
        count: 0,
        categoryId: 7,
        postId: this.$route.params.id,
      };
      await this.postStore.getPostById(postData);
    },

    fullUrl(path) {
      // nëse URL është absolute, mos e prek
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return this.baseUrl + path;
    },

    async showPostInModal(imageUrl) {
      if (!imageUrl)
        return Swal.fire('Gabim', 'Nuk ka imazh për këtë postim.', 'error');

      await Swal.fire({
        html: `<img src="${imageUrl}" style="max-width: 100%; border-radius: 8px;" />`,
        showCloseButton: true,
        focusConfirm: false,
        showConfirmButton: false,
        width: '90%',
      });
    },

    closeImageModal() {
      this.showModal = false;
      this.modalImageSrc = '';
    },
  },

  async created() {
    await this.fetchPostById();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
}
img {
  width: 50%;
  height: auto;
  margin-bottom: 1rem;
}
.extra-images img {
  transition: transform 0.2s;
}
.extra-images img:hover {
  transform: scale(1.05);
}
@media (max-width: 991px) {
  img {
    width: 100% !important;
  }
}
</style>
